module.exports = {
  "./packages/@react-spectrum/s2/stories/Accordion.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Accordion.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ActionBar.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ActionBar.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ActionButton.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ActionButton.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ActionButtonGroup.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ActionButtonGroup.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ActionMenu.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ActionMenu.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/AlertDialog.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/AlertDialog.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Avatar.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Avatar.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/AvatarGroup.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/AvatarGroup.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Badge.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Badge.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Breadcrumbs.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Breadcrumbs.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Button.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Button.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ButtonGroup.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ButtonGroup.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Card.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Card.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/CardView.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/CardView.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Checkbox.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Checkbox.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/CheckboxGroup.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/CheckboxGroup.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/CoachMark.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/CoachMark.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ColorArea.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ColorArea.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ColorField.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ColorField.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ColorSlider.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ColorSlider.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ColorSwatch.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ColorSwatch.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ColorSwatchPicker.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ColorSwatchPicker.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ColorWheel.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ColorWheel.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ComboBox.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ComboBox.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ContextualHelp.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ContextualHelp.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/CustomDialog.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/CustomDialog.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Dialog.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Dialog.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Disclosure.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Disclosure.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Divider.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Divider.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/DropZone.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/DropZone.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Form.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Form.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/FullscreenDialog.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/FullscreenDialog.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Icon.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Icon.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/IllustratedMessage.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/IllustratedMessage.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/InlineAlert.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/InlineAlert.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Link.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Link.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/LinkButton.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/LinkButton.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Menu.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Menu.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Meter.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Meter.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/NumberField.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/NumberField.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Picker.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Picker.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Popover.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Popover.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ProgressBar.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ProgressBar.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ProgressCircle.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ProgressCircle.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/RadioGroup.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/RadioGroup.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/RangeSlider.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/RangeSlider.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/SearchField.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/SearchField.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/SegmentedControl.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/SegmentedControl.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Slider.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Slider.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/StatusLight.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/StatusLight.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/StyleMacro.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/StyleMacro.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Switch.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Switch.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/TableView.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/TableView.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Tabs.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Tabs.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/TagGroup.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/TagGroup.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/TextField.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/TextField.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ToggleButton.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ToggleButton.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/ToggleButtonGroup.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/ToggleButtonGroup.stories.tsx"),

  "./packages/@react-spectrum/s2/stories/Tooltip.stories.tsx": () => import("../../../packages/@react-spectrum/s2/stories/Tooltip.stories.tsx"),

};
